import { styled } from "@mui/material/styles";

export const ConvoInsightsContainer = styled("div")(({ theme }) => ({
  "& h2": {
    margin: "0 0 15px 0",
    fontSize: "20px",
    lineHeight: "1.2",
    "& span": {
      display: "block",
      fontSize: "16px",
      fontWeight: "normal",
      opacity: ".8",
      marginTop: "10px",
      lineHeight: "1.4",
    },
  },
  "& .upload-container": {
    flexGrow: 1,
    padding: "24px",
    boxShadow:
      "0px 12px 16px -4px rgba(0, 91, 140, 0.10), 0px 4px 6px -2px rgba(0, 91, 140, 0.03), 0px 2px 2px -1px rgba(0, 91, 140, 0.04)",
    border: `2px solid`,
    borderColor: theme.palette.border.tertiary,
    borderRadius: "8px",
    marginBottom: "20px",
    "& .heading-container": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "30px",
      gap: "20px",
      [theme.breakpoints.down("sm")]: {
        display: "block",
      },
      "& .category-select": {
        "& .input-field": {
          marginBottom: "0px",
                [theme.breakpoints.down("sm")]: {
     marginTop: "10px"
      },
          "& label": {
            color: "#D1C7FF",
            fontSize: "14px"
          },
          "& .custom-select-wrapper": {
            margin: "5px 0 0 0",
          },
          "& .help-text": {
            color: "#ccc",
            fontSize: "13px",
            fontStyle: "italic",
          },
        },
      },
      "& h2": {
        marginBottom: 0,
      },
    },
    "& .dropzone": {
      border: "1px solid rgba(254, 254, 254, 0.25)",
      background: "#211F45",
    },
    "& .form-container": {
      borderTop: "#211F45 1px solid",
      paddingTop: "20px",
      position: "relative",
      "&.uploading form": {
        opacity: ".3"
      },
      "& .uploading-loading": {
        position: "absolute",
        zIndex: "99",
        width: "100%",
        height: "100%",
        // background: "rgba(255,255,255,.2)",
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
        gap: "10px"
      },
      "& .input-field": {
        marginBottom: "20px",
        color: "#D1C7FF",
        "& input": {
          margin: "10px 0",
        },
        "& .help-text": {
          color: "#ccc",
          fontSize: "13px",
          fontStyle: "italic",
        },
      },
    },
  },
  "& .what-next": {
    marginTop: "20px",
    // background: "#211F45",
    boxShadow:
      "0 12px 16px -4px rgba(255, 255, 255, 0.08), 0 4px 6px -2px rgba(255, 255, 255, 0.03), 0 2px 2px -1px rgba(255, 255, 255, 0.04)",
    padding: "24px",
    borderRadius: "8px",
    border: "1px solid rgba(254, 254, 254, 0.25)",
    marginBottom: "20px",
    "& ul": {
      display: "flex",
      flexWrap: "wrap",
      margin: "20px 0 0 0",
      padding: 0,
      listStyle: "none",
      gap: "20px",

      "& li": {
        display: "flex",
        width: "calc(50% - 10px)",
        fontWeight: 400,
        fontSize: "15px",
        alignItems: "center",
        "@media (max-width: 600px)": {
          width: "100%",
        },

        "& svg": {
          marginRight: "10px",
        },
      },
    },
  },
  "& .actions": {
    display: "flex",
    justifyContent: "flex-end",
  },
}));
